import { Schedule } from '../../types';
import Applicant from './Applicant';

interface Props {
  schedule: Schedule;
}

export default function ScheduleIdentity({ schedule }: Props) {
  return (
    <div className="flex flex-col">
      <Applicant participants={schedule.participants ?? []} tone="text-slate-600" />
      <span className="text-xs text-slate-400">
        #{schedule.external_id ?? schedule.id}
      </span>
    </div>
  );
}
